import dayjs from 'dayjs';

import { DisplayDateFormat } from '@xemplo/date-time';

import { DateCellProps } from './cell.types';

/**
 * Keeps for backward compatibility.
 * @deprecated use <DateCell /> instead.
 */
export const StartDateCell = (props: { date: Date; format?: string }) => {
  const { date, format = DisplayDateFormat.Medium } = props;
  const output = dayjs(date).format(format);
  return <div>{output}</div>;
};

/** Generic date cell with formatting capabilities. */
export function DateCell({ date, format }: DateCellProps) {
  const output = date ? dayjs(date).format(format) : '';
  return <span>{output}</span>;
}
